import component from "./ProfileAlertRaised.vue"

import wrapVueComponent from "@/utils/wrapVueComponent"
const componentName = "StudentProfileAlertRaised"

export default wrapVueComponent(componentName, component)
